import { TourStep } from '../../models/tour.model';

export const DEAL_FILTER_TOUR: TourStep[] = [
  {
    title: 'Finding Deals in Semeris Docs',
    element: '.sidenav-content semeris-sidenav-item#menu-item-deals',
    position: 'right',
    intro: `
        <p>The <i class="material-icons">gavel</i> <b>Deals</b> page shows the deal universe in your selected asset class.</p>
        <p>In this tour, you'll learn to:</p>
        <ul>
          <li>find deals and managers</li>
          <li>understand deal status indicators</li>
          <li>create custom deal filters</li>
        </ul>
        <p><i>Let's dive in!</i></p>
      `,
  },
  {
    title: 'Quick Search',
    element: 'semeris-search-input',
    intro: `
        <p>Enter keywords here to <b>filter by deals and managers</b> instantly.</p>
    `,
  },
  {
    title: 'Finding Deals in Toolbar Search',
    element: 'semeris-search-box',
    intro: `
        <p>You can also find deals from any page using the <b>Toolbar Search</b>.</p>
        <p>Simply type in a deal or manager name, and the system will provide <b>suggestions</b>.</p>
        <p>You can jump directly to the selected deal or open the <i class="material-icons">gavel</i> Deals page with that specific search.</p>
      `,
  },
  {
    title: 'Understanding Deal Information',
    element: 'div.deal-filter-transaction-table',
    position: 'bottom',
    intro: `
        <p>In the deal list each row provides key details about a deal:</p>
        <ul>
            <li><b>Actions</b> - Add to selected deals or apply deal filters.</li>
            <li><b>Deal traffic light</b> - Analysis status indicator.</li>
            <li><b>Deal Details</b> - Deal name, manager, issue date, and other relevant data.</li>
        </ul>
        <p>Decoding the traffic lights:</p>
        <ul style="list-style-type: none;">
            <li><i class="material-icons" style="color: var(--traffic-light-green);">circle</i> Green - Deals verified by analysts.</li>
            <li><i class="material-icons" style="color: var(--traffic-light-amber);">circle</i> Amber - Verified deals for which access confirmation is required.</li>
            <li><i class="material-icons" style="color: var(--traffic-light-gray);">circle</i> Gray - Deals not yet analyzed.</li>
        </ul>
    `,
  },
  {
    title: 'All Deals vs Deal Filters',
    element: '#deal-filter-switch',
    position: 'bottom',
    intro: `
        <p>By default, the list includes <b>all deals</b> from all your <b>public</b> and <b>private</b> <i class="material-icons" style="color: var(--semeris-gray);">lock</i> libraries.</p>
        <p>Toggle this selector for a <b>filtered view</b>.</p>
      `,
  },
  {
    title: 'Selecting a Deal Filter',
    element: 'semeris-deal-filter-selector',
    position: 'bottom',
    intro: `
        <p>A <b>Deal Filter</b> is a powerful tool to define your own deal universe.</p>
        <p>This <i class="material-icons" style="color: var(--semeris-gray);">filter_alt</i> dropdown lets you select a <b>Deal Filter</b> and deal list will adjust accordingly.</p>
      `,
  },
  {
    title: 'Creating a Deal Filter',
    element: '.header-controls .new-deal-filter-button',
    position: 'left',
    intro: `
        <p>The <i class="material-icons">add</i> icon creates a new <b>Deal Filter</b>.</p>
      `,
  },
  {
    title: 'Setting Deal Filter Rules',
    element: 'semeris-filter-form',
    position: 'left',
    intro: `
        <p>First, name your filter. Then, define your <b>Filtering Rules:</b></p>
        <ul>
          <li><b>Specified Deals</b> - Always include these.</li>
          <li><b>Managers</b> - Select specific managers.</li>
          <li><b>All Libraries</b></li>
          <li><b>Specified Libraries</b> - Pick libraries; 'x' to remove.</li>
          <li><b>Asset Classes</b> - Choose classes.</li>
          <li><b>Quarter</b> - Select quarters/years.</li>
          <li><b>Curation State</b> - Verified or non-verified deals.</li>
          <li><b>Most Recent</b> - Display latest N deals.</li>
        </ul>
        <p>Additionally, you can choose:</p>
        <ul>
          <li>Last uploaded issuance only</li>
          <li>At least one document</li>
          <li>Group by manager</li>
        </ul>
        <p>Filtered lists automatically update with future deals.</p>
      `,
  },
  {
    title: 'Import Transaction Identifiers',
    element: '.import-hint',
    position: 'left',
    intro: `
        <p>Another way to create a filter is to <b>import a list of deal identifiers or tickers</b>.</p>
        <p>A step-by-step wizard guides you through the process.</p>
      `,
  },
  {
    title: 'Sharing Within Your Organization',
    element: '#deal-filter-share-icon',
    position: 'left',
    intro: `
        <p>By default, when you create a Deal Filter, it remains <b>private to you</b>.</p>
        <p>Using the <i class="material-icons">share</i> icon, you can make it accessible to your organization.</p>
        <p>In Semeris Docs, you have the flexibility to either keep customizations private or <b>share them with your organization</b>.</p>
      `,
  },
  {
    title: 'Using Deal Filters',
    intro: `
        <p>You'll find Deal Filter <i class="material-icons" style="color: var(--semeris-gray);">filter_alt</i> selectors throughout the system, especially in:</p>
        <ul>
            <li>Deal Compare</li>
            <li>Market Compare</li>
            <li>Text Search</li>
            <li>Similar Paragraph Search</li>
            <li>Term Explorer</li>
            <li>and more</li>
        </ul>
        <p>Using a Deal Filter narrows reports to relevant deals.</p>
        <p><i>This concludes your tour about finding deals.</i></p>
      `,
  },
];
